import { Link, useLocation } from 'react-router-dom';
import { filter } from 'lodash';
import { McIcon, McSideBar } from '@maersk-global/mds-react-wrapper';

import useUserSessionContext from '../hooks/contexts/useUserSessionContext';

const AppSideBar = () => {
  const { userSession } = useUserSessionContext();
  const roles = userSession?.roles;
  const { pathname } = useLocation();

  const menus = {
    dashboard: {
      link: '/',
      icon: 'house',
      label: 'Dashboard',
      visible: roles?.user || roles?.onDemand,
    },
    integrations: {
      link: '/integrations',
      icon: 'check-circle',
      label: 'Integração',
      visible: roles?.support || roles?.onDemand,
    },
    integrationsGollum: {
      link: '/integrationsGollum',
      icon: 'check-circle-half-dashed',
      label: 'Integração Gollum',
      visible: roles?.support,
    },
    registrations: {
      link: '/registrations',
      icon: 'folder-open',
      label: 'Cadastros',
      visible: roles?.support,
    },
    synchro: {
      link: '/synchro',
      icon: 'file-pdf',
      label: 'Synchro',
      visible: roles?.fiscal,
    },
    ctetms: {
      link: '/ctetms',
      icon: 'folder-arrow-down',
      label: 'Carga CTE TMS',
      visible: roles?.support,
    },
  };

  const visibleMenus = filter(menus, Boolean);
  // TODO: remove this temp workaround as soon integration with
  // authorizer is working
  // const visibleMenus = filter(menus, { visible: true });

  return (
    <McSideBar open>
      <nav
        className="mds-tree-nav"
        role="navigation"
        aria-label="side navigation with icons"
      >
        <ul>
          {!!visibleMenus.length &&
            visibleMenus.map((menu) => {
              const isActive = pathname === menu.link;

              return (
                <li
                  key={menu.link}
                  onClick={() => {
                    localStorage.setItem('[mds-sidebar]open', 'false');
                  }}
                >
                  <Link
                    to={menu.link}
                    {...(isActive
                      ? {
                          ariaCurrent: 'page',
                          className: 'mds-tree-nav__active',
                        }
                      : {})}
                  >
                    <McIcon icon={menu.icon} size="20"></McIcon>
                    {menu.label}
                  </Link>
                </li>
              );
            })}
        </ul>
      </nav>
    </McSideBar>
  );
};

export default AppSideBar;
